import React, { useCallback, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ProfileContainer from 'features/profile/ProfileContainer';
import Dashboard from 'features/dashboard/components/Dashboard';
import NotFound from 'components/common/NotFound';
import Forbidden from 'components/common/Forbidden';
import InsuranceDocumentRootContainer from 'features/insuranceDocument/edit/root/components/InsuranceDocumentRootContainer';
import InsuranceDocumentListBrowser from 'features/insuranceDocument/list/components/InsuranceDocumentListBrowser';
import SettingsContainer from 'features/settings/components/SettingsContainer';
import RcaFlowChecksContainer from 'features/settings/components/flowChecks/rcaChecks/RcaFlowChecksContainer';
import CascoFlowChecksContainer from 'features/settings/components/flowChecks/cascoChecks/CascoFlowChecksContainer';
import LogListBrowser from 'features/logs/list/components/LogListBrowser';
import LogDetailContainer from 'features/logs/edit/components/LogDetailContainer';
import PolicyRenewalListBrowserContainer from 'features/policyRenewal/components/PolicyRenewalListBrowserContainer';
import OverRouterSubscriptionArea from '../features/insuranceDocument/edit/root/components/OverRouterSubscriptionArea';
import { useOverRouterContext, useAuthUserData } from 'hooks';
import { useHistory } from 'react-router-dom';
import CustomRoute from 'components/routing/CustomRoute';

export default function AppRoutes() {
  const contextRef = useOverRouterContext();
  const { authUser } = useAuthUserData();
  const history = useHistory();

  useEffect(() => {
    if (authUser?.hasAccess === false) {
      history.push('/forbidden');
    }
  }, [authUser, history]);

  const InsuranceDocumentRootContainerWrapper = useCallback(() => <InsuranceDocumentRootContainer contextRef={contextRef} />, [contextRef]);

  return (
    <>
      <Switch>
        <Route exact path='/'>
          <Redirect to='/dashboard' />
        </Route>
        <Route exact path='/my-profile'>
          <CustomRoute component={ProfileContainer} />
        </Route>
        <Route exact path='/dashboard'>
          <CustomRoute component={Dashboard} />
        </Route>
        <Route exact path='/insurance-documents'>
          <CustomRoute component={InsuranceDocumentListBrowser} />
        </Route>
        <Route exact path='/insurance-documents/:id(new)'>
          <CustomRoute component={InsuranceDocumentRootContainerWrapper} />
        </Route>
        <Route path='/insurance-documents/:id(\d+)'>
          <CustomRoute component={InsuranceDocumentRootContainerWrapper} />
        </Route>
        <Route exact path='/settings'>
          <CustomRoute component={SettingsContainer} />
        </Route>
        <Route exact path='/settings/rca-checks'>
          <CustomRoute component={RcaFlowChecksContainer} />
        </Route>
        <Route exact path='/settings/casco-checks'>
          <CustomRoute component={CascoFlowChecksContainer} />
        </Route>
        <Route exact path='/logs'>
          <CustomRoute component={LogListBrowser} />
        </Route>
        <Route exact path='/renewal'>
          <CustomRoute component={PolicyRenewalListBrowserContainer} />
        </Route>
        <Route exact path='/logs/:id'>
          <CustomRoute component={LogDetailContainer} />
        </Route>
        <Route exact path='/forbidden'>
          <Forbidden />
        </Route>
        <Route path='*'>
          <NotFound />
        </Route>
      </Switch>
      <OverRouterSubscriptionArea contextRef={contextRef} />
    </>
  );
}
